// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__Eo4vJ","button":"styles_button__Qxm8Q","selected":"styles_selected__jTbpk"};